export const bgAuth = {
  styles: {
    global: (props) => ({
      body: {
        bg: "linear-gradient(135deg, #0a0f0d 0%, #0d1512 25%, #111a16 50%, #0d1512 75%, #0a0f0d 100%)",
        bgSize: "cover",
        bgPosition: "center center",
      },
    }),
  },
};
